import { render } from "./MyCourses.vue?vue&type=template&id=4757bf6c&scoped=true"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"

import "./MyCourses.vue?vue&type=style&index=0&id=4757bf6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4757bf6c"]])

export default __exports__